import { render } from "./TheProgressBar.vue?vue&type=template&id=3a3db2b4"
import script from "./TheProgressBar.vue?vue&type=script&lang=js"
export * from "./TheProgressBar.vue?vue&type=script&lang=js"
script.render = render

export default script